// Module
var code = "<div>\r\n  <rzslider rz-slider-options=\"$ctrl.options\" rz-slider-model=\"$ctrl.model\"></rzslider>\r\n</div>\r\n";
// Exports
var _module_exports = code;;
var path = 'app/portainer/components/slider/slider.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;